var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
// React
import React from "react";
import { connect } from "react-redux";
// Router
import * as appRouting from "appRouting";
// Components
import CardPanel from "common/ui/components/nav/cardPanel/CardPanel";
import Card from "common/ui/components/nav/cardPanel/Card";
// Helpers
import NamingHelper from "common/utils/namingHelper";
const mapStateToProps = (state) => ({});
const mapDispatchToProps = (dispatch) => ({});
//-- Component -------------------------------------------------------------------------------------------------------------------------------
let OfficeReportsOptions = class OfficeReportsOptions extends React.Component {
    render() {
        let officeId = this.props.officeId;
        return (React.createElement(CardPanel, { title: NamingHelper.reports, titleColour: "#669548" },
            React.createElement(Card, { url: appRouting.officeStatsReportUrl(officeId), label: NamingHelper.officeOverview, description: "See your office statistics." }),
            React.createElement(Card, { url: appRouting.officeAgentsReportUrl(officeId), label: NamingHelper.officeAgents, description: "This report provides information on all of your agents over a selected date range." }),
            React.createElement(Card, { url: appRouting.officeListingReportUrl(officeId), label: NamingHelper.officeActiveListings, description: "This report provides a snapshot of the listings you currently have listed on Private Property (as of yesterday)." }),
            React.createElement(Card, { url: appRouting.officeLeadsReportUrl(officeId), label: NamingHelper.officeMessageLeads, description: "This report shows information about all leads received by your agents or office over a selected date range." })));
    }
};
OfficeReportsOptions = __decorate([
    connect(mapStateToProps, mapDispatchToProps)
], OfficeReportsOptions);
export default OfficeReportsOptions;
